exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-detail[data-v-782f4338] {\n  min-width: 100px !important;\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n", ""]);

// exports
